import {
  Field,
  FieldContent,
  FieldDescription,
  FieldGroup,
  FieldLabel,
  FieldSet,
  FieldTitle,
} from "@/client/components/shad/field";
import {
  RadioGroup,
  RadioGroupItem,
} from "@/client/components/shad/radio-group";
import {
  SidebarContent,
  SidebarHeader,
} from "@/client/components/shad/sidebar";
import { MapControls } from "@/client/features/map/MapContols";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(protected)/map/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="">
      <SidebarHeader className=" text-sm border-b px-3 py-4">
        Map View
      </SidebarHeader>
      <SidebarContent className="p-3 text-xs py-5">
        <MapControls />
      </SidebarContent>
    </div>
  );
}
